<template>
    <div id="AIKnowledgeCreateForm" class="content">
        <div>{{ title }}</div>
        <input v-model="questionItemTexts" type="text" :disabled="true" />
        <div>Scenarios</div>
        <a-select
            class="select-story"
            :placeholder="$t('message.chooseAiStory')"
            :filter-option="false"
            v-model="selectedStoryId"
        >
            <a-select-option :value="story._id" v-for="story of filteredStories" :key="story._id">
                <span class="blockTypeText">{{ story.title }}</span>
            </a-select-option>
        </a-select>
        <div>{{ description }}</div>
        <textarea v-model="answer"></textarea>
        <div class="btn-container">
            <SupsisButton primary class="sup-btn" @click="saveFaq">
                <i class="material-icons">save</i>
                <span>{{ $t("message.save") }}</span>
            </SupsisButton>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import { sendSocketMessage } from "../../../../../utils/socketStream";

export default {
    name: "CreateFaqs",
    components: { SupsisButton },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        questionItem: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            question: "",
            answer: "",
            selectedStoryId: null,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
        }),
        filteredStories() {
            return this.stories.filter((story) => story.ai !== undefined);
        },
        questionItemTexts: {
            get() {
                return this.questionItem.map((item) => item.text).join(", ");
            },
            set(newValue) {
                const texts = newValue.split(",").map((text) => text.trim());
                this.questionItem.forEach((item, index) => {
                    if (texts[index] !== undefined) {
                        item.text = texts[index];
                    }
                });
            },
        },
    },
    methods: {
        openAiAdded() {
            sendSocketMessage("chatbot/v2 kb-faq-added", {
                siteId: this.site._id,
                storyId: this.selectedStoryId,
                isAssistantAPI: !!this.$store.state.CB.stories.find((story) => story._id === this.selectedStoryId)?.ai
                    ?.assistantId,
            });
        },
        openAiRemoved() {
            sendSocketMessage("chatbot/v2 kb-faq-removed", {
                siteId: this.site._id,
                storyId: this.selectedStoryId,
                isAssistantAPI: !!this.$store.state.CB.stories.find((story) => story._id === this.selectedStoryId)?.ai
                    ?.assistantId,
            });
        },
        async saveFaq() {
            if (!this.selectedStoryId) {
                this.$message.error("Please select a story.");
                return;
            }
            await CHATBOT_API.KNOWLEDGE_BASE.createKnowledgeBase(this.selectedStoryId, "faq", undefined, undefined, {
                question: this.questionItemTexts,
                answer: this.answer,
            }).then((res) => res.data);
            this.openAiRemoved();
            this.openAiAdded();
            this.$message.success("FAQ is created.");
            this.$emit("faqCreated");
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 10px;
}

.content div {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.content input[type="text"],
.content textarea {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    width: 100%;
}

.content textarea {
    height: 400px;
    resize: vertical;
}

.sup-btn {
    float: right;
    color: white !important;
}
</style>
